import { useState } from "react";
import { UomMapping as RetailerLevelUomMapping } from "./retailer-level";
import { UomMapping as BranchLevelUomMapping } from "./branch-level";

export const UomMapping = () => {
  const [isBranchLevel, setIsBranchLevel] = useState(false);

  return isBranchLevel ? (
    <BranchLevelUomMapping
      isBranchLevel={isBranchLevel}
      onLevelChange={setIsBranchLevel}
    />
  ) : (
    <RetailerLevelUomMapping
      isBranchLevel={isBranchLevel}
      onLevelChange={setIsBranchLevel}
    />
  );
};
